import React from 'react';
import styled from 'styled-components';

const Highlight = styled.mark`
  background-color: #FFD700;
  color: #000;
  padding: 2px 0;
  font-weight: bold;
  border-radius: 2px;
`;

/**
 * Highlights matching text within a string based on search query
 * @param {string} text - The text to search within
 * @param {string} query - The search query
 * @returns {React.Element} - Text with highlighted matches
 */
export function highlightText(text, query) {
  if (!text || !query || typeof text !== 'string') {
    return text;
  }

  // Split query into individual terms
  const terms = query.trim().split(/\s+/).filter(term => term.length > 2);

  if (terms.length === 0) {
    return text;
  }

  // Create a regex pattern that matches any of the search terms (case-insensitive)
  const pattern = terms.map(term =>
    term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // Escape special regex characters
  ).join('|');

  const regex = new RegExp(`(${pattern})`, 'gi');

  // Split text by matches and wrap matches in Highlight component
  const parts = text.split(regex);

  return (
    <>
      {parts.map((part, index) => {
        // Check if this part matches any search term
        const isMatch = regex.test(part);
        regex.lastIndex = 0; // Reset regex state

        return isMatch ? (
          <Highlight key={index}>{part}</Highlight>
        ) : (
          <React.Fragment key={index}>{part}</React.Fragment>
        );
      })}
    </>
  );
}
